import { useState } from 'react';
import { Trophy } from 'lucide-react';

import type { Achievement } from '@/lib/api/achievements';

interface Props {
  achievements: Achievement[];
}

function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export function AchievementsCard({ achievements }: Props) {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? achievements : achievements.slice(0, 3);

  return (
    <section className="rounded-xl border border-[#e8e4df] bg-white p-6" aria-label="Achievements">
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-base font-bold text-[#1a1714]">Achievements</h2>
        {achievements.length > 3 && (
          <button
            type="button"
            onClick={() => setShowAll((v) => !v)}
            className="rounded-full border border-[#e8e4df] px-3 py-1 text-xs font-medium text-[#1a1714] hover:bg-[#faf9f7]"
          >
            {showAll ? 'Show Less' : 'View All'}
          </button>
        )}
      </div>
      {achievements.length === 0 ? (
        <p className="mt-4 text-sm text-[#9a9589]">No achievements yet — keep learning!</p>
      ) : (
        <ul className="mt-4 space-y-4">
          {visible.map((a) => (
            <li key={a.key} className="flex gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#fef3ea]">
                <Trophy className="h-4 w-4 text-[#e8660d]" />
              </span>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-[#1a1714]">{a.title}</p>
                <p className="text-xs text-[#9a9589]">{a.description}</p>
                <p className="mt-0.5 text-[11px] text-[#c4c0b8]">{formatDate(a.unlocked_at)}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
